"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VMEndpoint = void 0;
var VMEndpoint;
(function (VMEndpoint) {
    VMEndpoint["RENDER"] = "qrender";
    VMEndpoint["FUNCTION_SIGNATURES"] = "qfuncs";
    VMEndpoint["EVALUATE"] = "qeval";
    VMEndpoint["FILE_CONTENT"] = "qfile";
})(VMEndpoint || (exports.VMEndpoint = VMEndpoint = {}));
